import { render } from "./MiListItemLabel.vue?vue&type=template&id=38935d83"
import script from "./MiListItemLabel.vue?vue&type=script&lang=js"
export * from "./MiListItemLabel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItemLabel});
